// extracted by mini-css-extract-plugin
export default {"map":"ConfirmAddressBlock_map__8Wh5a","informationBlockContent":"ConfirmAddressBlock_informationBlockContent__1QFj2","addressText":"ConfirmAddressBlock_addressText__jcqt6"};